import { PropsWithChildren } from 'react';

import classes from 'components/common/Tables/components/TableContainer/TableContainer.module.scss';

interface Props extends PropsWithChildren {
    className?: string;
}

export const TableContainer = ({ children, className }: Props) => {
    return (
        <div data-testid={'table-container'} className={`${classes.TableContainer} ${className ?? ''}`}>
            {children}
        </div>
    );
};
